import * as EsignActions from './esign.actions';

export const esignActions = {
    EsignActions
};
